import { useNavigate } from "react-router-dom";

// components
import PageLayout from "../../components/PageLayout"

// icons
import IconComponent from "../../components/Icon";
import { PiBooks } from "react-icons/pi";
import { FaPencil } from "react-icons/fa6";

const Admin = () => {
    const navigate = useNavigate();
   
    return (
        <PageLayout
            headerText="Admin dashboard"
        >
            <div>
                 <div className="grid md:grid-cols-2 grid-cols-1 gap-x-[40px] mt-[40px] cursor-pointer">
                     <div className="bg-white hover:bg-[#F7F7F7] rounded-3xl shadow-lg p-4 min-h-20 md:mt-0 mt-[40px]" onClick={() => navigate('/admin/editBook')}>
                        <div className="flex justify-between items-center h-full">
                            <h1 className="text-2xl font-bold mb-0 text-[#60637A]">
                                Edit book metadata
                            </h1>
                            <IconComponent className="size-12 rotate-[-20deg] opacity-45" color="#BBCFD8" icon={FaPencil} />
                        </div>

                     </div>
                     <div className="bg-white hover:bg-[#F7F7F7] rounded-3xl shadow-lg p-4 min-h-20 md:mt-0 mt-[40px]"  onClick={() => navigate('/admin/addSerie')}>
                         <div className="flex justify-between items-center h-full">
                            <h1 className="text-2xl font-bold mb-0 text-[#60637A]">
                                Edit/Add serie
                            </h1>
                            <IconComponent className="size-16  opacity-45" color="#BBCFD8" icon={PiBooks} />
                        </div>
                     </div>
                 </div>
                
            </div>
        </PageLayout>
    )
    
}

export default Admin